import React, { useEffect, useMemo, useState } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import ImageResize from "quill-image-resize-module-react";

window.Quill = Quill;
let quillObj: ReactQuill;

const BaseImageFormat = Quill.import("formats/image");
const ImageFormatAttributesList = ["alt", "height", "width", "style"];

class ImageFormat extends BaseImageFormat {
  static formats(domNode) {
    return ImageFormatAttributesList.reduce(function (formats, attribute) {
      if (domNode.hasAttribute(attribute)) {
        formats[attribute] = domNode.getAttribute(attribute);
      }
      return formats;
    }, {});
  }
  format(name, value) {
    if (ImageFormatAttributesList.indexOf(name) > -1) {
      if (value) {
        this.domNode.setAttribute(name, value);
      } else {
        this.domNode.removeAttribute(name);
      }
    } else {
      super.format(name, value);
    }
  }
}

Quill.register(ImageFormat, true);

Quill.register("modules/imageResize", ImageResize);

export const Editor = ({
  style,
  disabled,
  html,
  onValueChange,
  onBlur
}: {
  style?;
  disabled?: boolean;
  html?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onValueChange?: (deltaOps: any[] | undefined, hasMedia: boolean) => void;
  onBlur?: () => void;
}) => {
  const [value, setValue] = useState("");

  const onChange = (e) => {
    console.log(e);
    console.log("IMA:", quillObj.editor?.getContents().ops);
    const imgRegex = /<img.*?>/g; // Regular expression to match <img> tags
    const hasMedia = imgRegex.test(e);
    setValue(e);
    if (onValueChange)
      onValueChange(quillObj.editor?.getContents().ops, hasMedia);
  };
  const modules = useMemo(() => {
    return {
      toolbar: disabled
        ? false
        : {
            container: [
              [{ font: [] }],
              [{ size: ["small", false, "large", "huge"] }],
              [
                "bold",
                "italic",
                "underline",
                "strike",
                "blockquote",
                "code-block"
              ],
              [{ color: [] }, { background: [] }],
              [
                { list: "ordered" },
                { list: "bullet" },
                { indent: "-1" },
                { indent: "+1" },
                { align: [] }
              ],
              ["link", "image"]
            ]
          },
      clipboard: {
        // toggle to add extra line breaks when pasting HTML:
        matchVisual: false
      },
      ...(disabled
        ? {}
        : {
            imageResize: {
              parchment: Quill.import("parchment"),
              modules: ["Resize", "DisplaySize", "Toolbar"]
            }
          })
    };
  }, []);
  useEffect(() => {
    if (html) {
      setValue(html);
    }
  }, [html]);
  return (
    <ReactQuill
      theme="snow"
      ref={(el) => {
        quillObj = el;
      }}
      value={value}
      readOnly={disabled}
      style={style ? style : {}}
      onChange={onChange}
      onBlur={() => {
        if (onBlur) onBlur();
      }}
      modules={modules}
    ></ReactQuill>
  );
};
